import React from 'react';

import {
  PREVIEW_PARTICIPANT_COLUMN_LABELS,
  PreviewParticipantColumnId,
} from './DrivePreviewPanel.constants';

export const PREVIEW_PARTICIPANTS_TABLE_CONFIG = Object.values(PreviewParticipantColumnId).reduce(
  (config, columnId) => ({
    ...config,
    [columnId]: {
      label: PREVIEW_PARTICIPANT_COLUMN_LABELS[columnId],
      content: row => <span className="table-cell__content_text">{row[columnId]}</span>,
    },
  }),
  {},
);
